import React, { useState, useEffect, useRef } from "react";
import Pagination from "../../shared/common/pagination";
import Loader from "../../shared/loader/loader";
import AddAndEditPracticeQuestion from "./managePracticeQustion";
import DeleteModal from "../../shared/common/deleteModal";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import { connect } from "react-redux";
import Constant from "../../../utils/constant";
import MultiSelectList from "../questions/metadataDropDownList";
import Tooltip from "../../shared/common/ellipsisText";
import {
  getSkillStandardAll,
  getSkillSubjectAll,
  getSkillQuestionAll,
  deleteSkillQuestionAPI,
} from "../../../api/skill.service";
import { useNavigate, Link } from "react-router";
import {
  AddIcon,
  EditIcon,
  DeleteIcon,
  FilterIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  ApproveIcon,
  Disapprove,
  CSVIcon,
} from "../../../assets/icons/index";
import ExportToCSV from "../../shared/common/exportToCsv";
import { toast } from "react-toastify";
import ActiveRowLine from "../../shared/common/activeRowLine";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiStateButton from "../../shared/common/multiStateButton";
const activeMultiState = [
  { label: "Active", value: true },
  { label: "Both", value: null, selected: true },
  { label: "Inactive", value: false },
];

const practiceQuestions: React.FC = (props: any) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const [showAddEditModal, setShowAddEditModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [newSkills, setNewSkills] = useState<any>([]);
  const [editQuestion, setEditQuestion] = useState<any>(null);
  const [deleteQuestion, setDeleteSkill] = useState<any>(null);
  const [gradeSubjects, setGradeSubjects] = useState<any>([]);
  const [standard, setStandard] = useState<any>([]);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [newGrade, setNewGrade] = useState<any>([]);
  const [newSkillSubject, setnewSkillSubject] = useState<any>([]);
  const [newpopSkillSubject, setnewpopSkillSubject] = useState<any>([]);
  const [newpopSkillStandard, setnewpopSkillStandard] = useState<any>([]);
  const [newStateId, setNewStateId] = useState<number>(0);
  const [newcontentAreaId, setcontentAreaId] = useState<number>(0);
  const [newOrderByColumn, setOrderByColumn] = useState<any>("skillQuestionId");
  const [SortDir, setSortDir] = useState<any>(false);
  const [SkillStandardId, setSkillStandardId] = useState<number>(0);
  const [SkillSubjectId, setSkillSubjectId] = useState<number>(0);
  const [editData, setEditData] = useState<any>([]);
  const [newSkillGrade, setNewSkillGrade] = useState<any>([]);
  const [newSkillStandard, setNewSkillStandard] = useState<any>([]);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [selectgradeId, setselectgradeId] = useState(0);
  const [selectSkilStandardId, setselectSkilStandardid] = useState(0);
  const [sortCol, setSortCol] = useState<string>("skillQuestionId");
  const [isApproved, setisApproved] = useState<boolean>(true);

  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);
  const navigate = useNavigate();
  const [SkillQuestionId, setSkillQuestionId] = useState("");
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const childRef: any = useRef(undefined);

  const deleteSkillHandler = (e, id) => {
    e.preventDefault();
    setShowDeleteModal(true);
    const deleteGrade = newSkills.find((skill) => skill.skillQuestionId === id);
    setDeleteSkill(deleteGrade);
  };

  const deleteRecordHandler = () => {
    const recordsAfterDelete: any[] = newSkills.filter(
      (subject: any) =>
        subject.skillQuestionId !== deleteQuestion.skillQuestionId
    );
    const userId = 1;
    deleteSkillQuestionAPI(
      deleteQuestion.skillQuestionId,
      props.profile?.userId
    );
    setTimeout(() => {
      questionDataReload();
      setShowDeleteModal(false);
    }, 1000);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const closeModal = () => {
    setShowAddEditModal(false);
  };

  const questionDataReload = async () => {
    setLoading(true);
    const response = getSkillQuestionAll(
      selectgradeId,
      selectSkilStandardId,
      SkillSubjectId,
      isApproved === false ? isApproved : true,
      isActive,
      0,
      sortCol,
      SortDir ? "asc" : "desc",
      pageSize,
      pageNumber
    );
    const data = (await response).data;
    setNewSkills(data.data);
    setTotalPages(Math.ceil(data.totalRecords / pageSize));
    setTotalRecords(data.totalRecords);
    setLoading(false);
  };

  async function subjects() {
    setLoading(true);
    const gradeSubjectsResponse = getSkillSubjectAll(
      newStateId,
      selectgradeId,
      newcontentAreaId,
      "",
      true,
      true,
      0,
      sortCol,
      SortDir ? "asc" : "desc",
      pageSize,
      pageNumber
    );
    const gradeSubjectsData = (await gradeSubjectsResponse).data;
    let formatObj = [];
    formatObj = gradeSubjectsData.data.map((eachGradeData) => {
      return {
        value: eachGradeData.skillSubjectId,
        label: `${eachGradeData.name}`,
      };
    });
    setnewSkillSubject(formatObj);
    setLoading(false);
  }

  const getGradeData = async () => {
    const service = await import("../../../api/subject.service");
    const response = service.getGradeAll(100, pageNumber);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setNewGrade(newGradeData);
  };

  async function gradeContent() {
    setLoading(true);
    const gradeSubjectsResponse = getSkillStandardAll(
      SkillStandardId,
      SkillSubjectId,
      selectgradeId,
      true,
      true,
      newOrderByColumn,
      SortDir ? "asc" : "desc",
      9999,
      1
    );
    const gradeSubjectsData = (await gradeSubjectsResponse).data;
    setGradeSubjects(gradeSubjectsData.data);
    const standard = gradeSubjectsData.data.map((_g) => {
      return {
        label: `(${_g.code}) ${_g.name}`,
        value: _g.skillStandardId,
      };
    });
    setStandard(standard);
    setLoading(false);
  }

  useEffect(() => {
    gradeContent();
    subjects();
    getGradeData();
  }, []);

  useEffect(() => {
    if (isLoaded) {
      questionDataReload();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      questionDataReload();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  const filterHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    const filteredSubject = [];
    getSkillQuestionAll(
      selectgradeId,
      selectSkilStandardId,
      SkillSubjectId,
      isApproved,
      isActive,
      SkillQuestionId ? SkillQuestionId : 0,
      sortCol,
      SortDir ? "asc" : "desc",
      defaultPageSize,
      defaultPageNumber
    ).then((res) => {
      const data = res.data;
      setNewSkills(data.data);
      setTotalPages(Math.ceil(data.totalRecords / defaultPageSize));
      setTotalRecords(data.totalRecords);
      setLoading(false);
    });

    setNewSkills(filteredSubject);
  };

  const handlePostRedirect = () => {
    const skillStandardToPass = gradeSubjects.map((_g) => {
      return {
        label: _g.name,
        value: _g.skillStandardId,
      };
    });
    const gradeDataToPass = newGrade.map((_g) => {
      return {
        label: _g.label,
        value: _g.value,
      };
    });
    navigate(Constant.ADDSKILLQUESTION, {
      state: {
        objectToEdit: null,
        standardData: skillStandardToPass,
        gradeData: gradeDataToPass,
      },
    });
  };

  const handleRedirect = (skills: any) => {
    const gradeDataToPass = newGrade.map((_g) => {
      return {
        label: _g.label,
        value: _g.value,
      };
    });
    const skillStandardToPass = gradeSubjects.map((_g) => {
      return {
        label: _g.name,
        value: _g.skillStandardId,
      };
    });
    setShowAddEditModal(true);
    const editSkill = newSkills.find(
      (skill) => skill.skillQuestionId === skills.skillQuestionId
    );

    let dropdownSelectedStandard = {};
    let dropdownSelectedGrade = {};
    const editSkills = gradeSubjects?.find(
      (item) => item.skillStandardId === editSkill.skillStandardId
    );
    const editGrades = newGrade?.find(
      (item) => item.value === editSkill.gradeId
    );
    dropdownSelectedStandard = {
      label: editSkills && editSkills?.name,
      value: editSkills && editSkills?.skillStandardId,
    };
    dropdownSelectedGrade = {
      label: editGrades && editGrades?.label,
      value: editGrades && editGrades?.value,
    };
    setNewSkillStandard(dropdownSelectedStandard);
    setNewSkillGrade(dropdownSelectedGrade);

    setEditQuestion(editSkill);
    navigate(
      Constant.MANAGESKILLQUESTION.replace(
        ":id",
        skills.skillQuestionId.toString()
      ),
      {
        state: {
          objectToEdit: skills,
          standardData: skillStandardToPass,
          selectStandardData: dropdownSelectedStandard,
          gradeData: gradeDataToPass,
          selectGradeData: dropdownSelectedGrade,
        },
      }
    );
  };

  const handleSortBy = (column: string) => {
    setSortDir(!SortDir);
    setSortCol(column);
  };

  const bindQuestions = () => {
    setLoading(true);
    getSkillQuestionAll(
      selectgradeId,
      SkillStandardId,
      SkillSubjectId,
      isApproved,
      isActive,
      SkillQuestionId ? SkillQuestionId : 0,
      sortCol,
      SortDir ? "asc" : "desc",
      pageSize,
      pageNumber
    ).then((response) => {
      setNewSkills(response.data.data);
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (isLoaded) bindQuestions();
  }, [SortDir]);

  const resetClickHandler = () => {
    setLoading(true);
    setPageNumber(1);
    setselectSkilStandardid(0);
    setselectgradeId(0);
    setSkillSubjectId(0);
    setisApproved(true);
    setIsActive(undefined);
    setSkillQuestionId("");
    setResetDropdownFlag(!resetDropdownFlag);
    getSkillQuestionAll(
      0,
      0,
      0,
      true,
      true,
      0,
      sortCol,
      SortDir ? "asc" : "desc",
      defaultPageSize,
      defaultPageNumber
    ).then((response) => {
      setNewSkills(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / defaultPageSize));
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    });
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
  };

  const exportFn = async () => {
    setLoading(true);

    const response = getSkillQuestionAll(
      selectgradeId ? selectgradeId : 0,
      selectSkilStandardId ? selectSkilStandardId : 0,
      SkillSubjectId,
      isApproved,
      isActive,
      SkillQuestionId ? SkillQuestionId : 0,
      sortCol,
      SortDir ? "asc" : "desc",
      9999,
      1
    );
    const data = (await response).data;
    setLoading(false);

    if (data && data.data && data.data.length > 0) {
      childRef?.current?.onDownload(data.data, "practiceQuestions.csv");
    } else {
      toast.warning("No records to download");
    }
  };

  return (
    <AllowedTo
      perform={Permissions.skill_practice_question_view}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      {showAddEditModal && (
        <AddAndEditPracticeQuestion
          closeModal={closeModal}
          showAddEditModal={showAddEditModal}
          editQuestion={editQuestion}
          contentData={gradeSubjects}
          newpopSkillSubject={newpopSkillSubject}
          newpopSkillStandard={newpopSkillStandard}
          editData={editData}
          newSkillGrade={newSkillGrade}
          newSkillStandard={newSkillStandard}
          questionDataReload={questionDataReload}
          userID={props.profile?.userId}
        />
      )}
      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div id="dataContainer" className="mt-4">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-light text-gray-900">
                  Skill Practice Question
                </h3>

                <AllowedTo perform={Permissions.skill_practice_question_create}>
                  <button
                    type="button"
                    className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                    onClick={() => handlePostRedirect()}
                  >
                    <AddIcon className="w-6"></AddIcon>
                    Add Skill Practice Question
                  </button>
                </AllowedTo>
              </div>
              <form action="#" onSubmit={filterHandler}>
                <div className="pt-6 border-b pb-6">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-2">
                      <label className="text-sm text-gray-700">
                        Skill Question Id
                      </label>
                      <div className="contentArea">
                        <input
                          id="name"
                          name="name"
                          type="text"
                          placeholder=""
                          className="mt-1 w-full block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                          value={SkillQuestionId}
                          onChange={(event: any) =>
                            setSkillQuestionId(event.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-span-2 ">
                      <label className="text-sm text-gray-700">Subject</label>
                      <div className="contentArea mt-1 text-sm">
                        <MultiSelectList
                          dropValue={newSkillSubject}
                          defaultValue={""}
                          value={SkillSubjectId}
                          resetDropdown={resetDropdownFlag}
                          dropSelect={setSkillSubjectId}
                          multiple={false}
                        />
                      </div>
                    </div>
                    <div className="col-span-2">
                      <label className="text-sm text-gray-700">Grade</label>
                      <div>
                        <div className="contentArea mt-1 text-sm">
                          <MultiSelectList
                            dropValue={newGrade}
                            defaultValue={""}
                            value={selectgradeId}
                            resetDropdown={resetDropdownFlag}
                            dropSelect={setselectgradeId}
                            multiple={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-span-2">
                      <label className="text-sm text-gray-700">Standard</label>
                      <div className=" contentArea mt-1 text-sm">
                        <MultiSelectList
                          dropValue={standard}
                          defaultValue={""}
                          value={selectSkilStandardId}
                          resetDropdown={resetDropdownFlag}
                          dropSelect={setselectSkilStandardid}
                          multiple={false}
                        />
                      </div>
                    </div>
                    <div className="col-span-2 flex items-center mt-6">
                      <MultiStateButton
                        labels={activeMultiState}
                        onSelect={(e) => setIsActive(e.value)}
                        onReset={resetDropdownFlag}
                      />
                    </div>

                    <div className="col-span-1 flex items-end">
                      <div className="flex items-center">
                        <input
                          id="isApproved"
                          name="isApproved"
                          type="checkbox"
                          checked={isApproved}
                          onChange={(e: any) => {
                            setisApproved(!isApproved);
                          }}
                          className=" focus:ring-primary-color mr-2 h-4 w-4 text-primary-color border-gray-300 rounded"
                        />
                        <label className=" text-sm text-gray-700">
                          Approved
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-start">
                    <button
                      type="submit"
                      className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    >
                      <FilterIcon className="w-3 h-3"></FilterIcon>
                      <span>Filter</span>
                    </button>
                    <button
                      type="button"
                      onClick={resetClickHandler}
                      className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                    >
                      <ResetIcon className="w-3 h-3"></ResetIcon>
                      <span>Reset Filter</span>
                    </button>
                  </div>
                </div>
                <div className="flex justify-end mb-2">
                  <button
                    type="button"
                    onClick={() => exportFn()}
                    className="mt-4 py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                    <span>Export</span>
                  </button>
                  <ExportToCSV ref={childRef} />
                </div>
              </form>
              <div className="flex flex-col mt-1">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-5 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex cursor-pointer">
                                Id
                                {SortDir && sortCol === "SkillQuestionId" ? (
                                  <CaretUpSolidIcon
                                    onClick={() =>
                                      handleSortBy("SkillQuestionId")
                                    }
                                    className="w-5 h-5"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() =>
                                      handleSortBy("SkillQuestionId")
                                    }
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex cursor-pointer">
                                Grade
                                {SortDir && sortCol === "grade" ? (
                                  <CaretUpSolidIcon
                                    onClick={() => handleSortBy("grade")}
                                    className="w-5 h-5 cursor-pointer"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() => handleSortBy("grade")}
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex cursor-pointer">
                                Standard
                                {SortDir && sortCol === "StandardName" ? (
                                  <CaretUpSolidIcon
                                    onClick={() => handleSortBy("StandardName")}
                                    className="w-5 h-5"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() => handleSortBy("StandardName")}
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex cursor-pointer">
                                Subject
                                {SortDir && sortCol === "SubjectName" ? (
                                  <CaretUpSolidIcon
                                    onClick={() => handleSortBy("SubjectName")}
                                    className="w-5 h-5"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() => handleSortBy("SubjectName")}
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex cursor-pointer">
                                Instruction
                                {SortDir && sortCol === "Instruction" ? (
                                  <CaretUpSolidIcon
                                    onClick={() => handleSortBy("Instruction")}
                                    className="w-5 h-5"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() => handleSortBy("Instruction")}
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              Question
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              Spanish
                            </th>
                            <th
                              scope="col"
                              className="w-10 px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {newSkills.map((skills, index) => (
                            <tr
                              key={skills.skillQuestionId}
                              className={
                                index % 2 === 0 ? "bg-white" : "bg-gray-100"
                              }
                            >
                              <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500 relative">
                                <ActiveRowLine isActive={skills.isActive} />
                                <Link
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  to={Constant.MANAGESKILLQUESTION.replace(
                                    ":id",
                                    skills.skillQuestionId.toString()
                                  )}
                                >
                                  {skills.skillQuestionId}
                                </Link>
                              </td>
                              <td className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline">
                                <Link
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                  to={Constant.EDITGRADE.replace(
                                    ":id",
                                    skills.gradeId
                                      ? skills.gradeId.toString()
                                      : ""
                                  )}
                                >
                                  {skills.gradeName}
                                </Link>
                              </td>
                              <td className="px-3 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                <Link
                                  to={Constant.MANAGESKILLSUBJECT.replace(
                                    ":id",
                                    skills.skillSubjectId
                                      ? skills.skillSubjectId.toString()
                                      : ""
                                  )}
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                >
                                  {skills.skillStandardName}
                                </Link>
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                <Link
                                  to={Constant.MANAGESKILLSUBJECT.replace(
                                    ":id",
                                    skills.skillSubjectId
                                      ? skills.skillSubjectId.toString()
                                      : ""
                                  )}
                                  className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                >
                                  {skills.skillSubjectName}
                                </Link>
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                {skills.instruction}
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                <Tooltip text={skills?.questionText} />
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                {skills.spanishQuestionText ? "Yes" : "No"}
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                                <div className="flex gap-3 justify-center">
                                  {skills.isApproved ? (
                                    <ApproveIcon />
                                  ) : (
                                    <Disapprove />
                                  )}

                                  <AllowedTo
                                    perform={
                                      Permissions.skill_practice_question_modify
                                    }
                                  >
                                    <EditIcon
                                      onClick={(e) => handleRedirect(skills)}
                                      className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                    />
                                  </AllowedTo>
                                  <AllowedTo
                                    perform={
                                      Permissions.skill_practice_question_delete
                                    }
                                  >
                                    <DeleteIcon
                                      onClick={(e) =>
                                        deleteSkillHandler(
                                          e,
                                          skills.skillQuestionId
                                        )
                                      }
                                      className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                    />
                                  </AllowedTo>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  {newSkills.length !== 0 ? (
                    <>
                      <Pagination
                        pages={totalPages}
                        setPageNumber={setPageNumber}
                        ref={paginationRef}
                      />
                      <span>
                        <span className="text-sm pr-4 ml-auto text-left-700">
                          Showing {pageNumber} to{" "}
                          {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                          {totalRecords} results
                        </span>

                        <SelectPageSize
                          setPageSize={setPageSize}
                          type={"second"}
                          ref={pageSizeRef}
                        />
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(practiceQuestions);
